// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iE8N","content":"styles_content__H_kMt"};